import React from "react";
import MagazynListPage from "./MagazynListPage";
import { ZWROTY_I_BLEDY } from "./magazynListConfigs";

// Zwroty i bledy (Magazyn Warszawa) - wspolny widok listy z konfiguracja tej listy.
const ZwrotyIBledy = () => <MagazynListPage config={ZWROTY_I_BLEDY} />;

export default ZwrotyIBledy;
